import {
  Box,
  Flex,
  Avatar,
  HStack,
  Link,
  Text,
  IconButton,
  Button,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  useDisclosure,
  useColorModeValue,
  Stack,
} from "@chakra-ui/react";
import { FiMenu, FiX } from "react-icons/fi";

interface NavLinkProps {
  label: string;
  link: string;
}

const NavLink = (props: NavLinkProps) => {
  const { label, link } = props;
  return (
    <Link
      px={2}
      py={1}
      rounded={"md"}
      _hover={{
        textDecoration: "none",
        bg: useColorModeValue("gray.200", "gray.700"),
      }}
      href={link}
    >
      {label}
    </Link>
  );
};

export default function NavBar() {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <Box
        bg={useColorModeValue("gray.100", "gray.900")}
        px={4}
        width="100%"
        position="fixed"
        zIndex={1}
      >
        <Flex h={20} alignItems={"center"} justifyContent={"space-between"}>
          <IconButton
            size="md"
            icon={isOpen ? <FiX /> : <FiMenu />}
            aria-label="Open Menu"
            display={{ md: "none" }}
            onClick={isOpen ? onClose : onOpen}
          />
          <HStack spacing={8} alignItems="center">
            <Box fontWeight="semibold">
              Dev
              <Text as="span" color="green.400">
                Lereko.
              </Text>
            </Box>
            <HStack as="nav" spacing={4} display={{ base: "none", md: "flex" }}>
              <NavLink label="Home" link="/" />
              <NavLink label="About" link="about" />
              <NavLink label="Projects" link="projects" />
              <NavLink label="Contact" link="contact" />
              <NavLink label="Resume" link="resume" />
            </HStack>
          </HStack>
          <Flex alignItems="center">
            <Menu>
              <MenuButton
                as={Button}
                rounded="full"
                variant="link"
                cursor="pointer"
                minW={0}
              >
                <Avatar size="sm" name="Dev Lereko" />
              </MenuButton>
              <MenuList>
                <MenuItem>About</MenuItem>
                <MenuItem>Profile</MenuItem>
                <MenuItem>Resume</MenuItem>
              </MenuList>
            </Menu>
          </Flex>
        </Flex>

        {isOpen ? (
          <Box pb={4} display={{ md: "none" }}>
            <Stack as={"nav"} spacing={4}>
              <NavLink label="Home" link="/" />
              <NavLink label="About" link="about" />
              <NavLink label="Projects" link="projects" />
              <NavLink label="Contact" link="contact" />
              <NavLink label="Resume" link="resume" />
            </Stack>
          </Box>
        ) : null}
      </Box>
    </>
  );
}
